// Anonymous visitor identity for traffic tracking. A UUID is generated once
// and kept in localStorage, so the same browser counts as one unique visitor
// across days/weeks/months. No personal data is stored or derivable from it.

const STORAGE_KEY = "demi_visitor_id";
const VALID_ID = /^[A-Za-z0-9-]{8,64}$/;

// In-memory fallback when localStorage is unavailable (private browsing,
// blocked storage). The visitor still counts, just only for this page load.
let ephemeralId = null;

function generateId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  const bytes = window.crypto.getRandomValues(new Uint8Array(16));
  return "v-" + Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

export function getVisitorId() {
  try {
    let id = window.localStorage.getItem(STORAGE_KEY);
    if (!id || !VALID_ID.test(id)) {
      id = generateId();
      window.localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch (_err) {
    if (!ephemeralId) ephemeralId = generateId();
    return ephemeralId;
  }
}
